module.exports = __webpack_public_path__ + "media/images/logo/logo_108x108-ffee9a8114e24580d2be3d91a1598e36.png";